import { configureStore } from "@reduxjs/toolkit";

import layoutReducer from "../features/layoutSlice";
import loginReducer from "../features/loginSlice";
import userReducer from "../features/userSlice";
import modalReducer from "../features/modalSlice";
import countryStateSlice from "../features/countryStateSlice";
import companyReducer from "../features/companySlice";
import gameReducer from "../features/gameSlice";
import itemReducer from '../features/itemSlice.js';
import discountReducer from '../features/discountSlice.js'
import challegeReducer from '../features/challengeSlice.js';
import dashboardReducer from '../features/dashboardSlice.js';
import carouselReducer from '../features/carouselSlice.js';
import subscriptionReducer from '../features/subscriptionSlice.js';
import topupReducer from '../features/topupSlice.js';
import categoryReducer from '../features/categorySlice.js';
import subCategoryReducer from '../features/subCategorySlice.js';
import mobsubscription from '../features/mobsubscriptionSlice';
import forgotPasswordReducer from '../features/forgotPasswordSlice.js'
import feedbackReducer from '../features/feedbackSlice.js'
import questPackReducer from '../features/questPackSlice.js'
import huntPackReducer from '../features/huntPackSlice.js'
import analyticsReducer from '../features/analyticsSlice.js'


const store = configureStore({
	reducer: {
		layout: layoutReducer,
		login: loginReducer,
		user: userReducer,
		modal: modalReducer,
		countryState: countryStateSlice,
		company: companyReducer,
		game: gameReducer,
		item: itemReducer,
		discount: discountReducer,
		challenge: challegeReducer,
		dashboard: dashboardReducer,
		carousel: carouselReducer,
		subscription: subscriptionReducer,
		topup: topupReducer,
		category: categoryReducer,
		subcategory: subCategoryReducer,
		mobsubscription:mobsubscription,
		forgotPassword: forgotPasswordReducer,
		feedback: feedbackReducer,
		questPack: questPackReducer,
		huntPack: huntPackReducer,
		analytics: analyticsReducer,

	},
});

export default store;
